import { c as _c } from "react/compiler-runtime";
import { startTransition, useCallback, useRef, useState } from "react";
export function useTruncation() {
  const $ = _c(3);
  const [isTruncated, setIsTruncated] = useState(false);
  const cleanupRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = element => {
      cleanupRef.current?.();
      cleanupRef.current = null;
      if (!element) {
        return;
      }
      const recalcTruncation = () => {
        startTransition(() => {
          setIsTruncated(element.scrollWidth > element.clientWidth);
        });
      };
      let raf = 0;
      const scheduleRecalc = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(recalcTruncation);
      };
      scheduleRecalc();
      let resizeObserver = null;
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver = new ResizeObserver(scheduleRecalc);
        resizeObserver.observe(element);
      }
      let mutationObserver = null;
      if (typeof MutationObserver !== "undefined") {
        mutationObserver = new MutationObserver(scheduleRecalc);
        mutationObserver.observe(element, {
          subtree: true,
          characterData: true,
          childList: true
        });
      }
      window.addEventListener("resize", scheduleRecalc);
      cleanupRef.current = () => {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", scheduleRecalc);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
        if (mutationObserver) {
          mutationObserver.disconnect();
        }
      };
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const valueRef = t0;
  let t1;
  if ($[1] !== isTruncated) {
    t1 = {
      valueRef,
      isTruncated
    };
    $[1] = isTruncated;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}